<template>
<div>

    <PropertyItem padded :header="'Checkbox properties'" :icon="'input-check'">

        <DesignerGroup c6>
            <DesignerCheckbox v-model="input.inline" :text="'Inline'" @before="$emit('propinput', 'check', 'check_prop', $event)" />
        </DesignerGroup>
        <DesignerGroup c6>
            <DesignerCheckbox v-model="input.radio" :text="'Radio'" @before="$emit('propinput', 'check', 'check_prop', $event)" />
        </DesignerGroup>
        <DesignerGroup c6>
            <DesignerCheckbox v-model="input.border" :text="'Bordered'" @before="$emit('propinput', 'check', 'check_prop', $event)" />
        </DesignerGroup>
        <DesignerGroup c6>
            <DesignerCheckbox v-model="input.fillCard" :text="'Fill card'" @before="$emit('propinput', 'check', 'check_prop', $event)" />
        </DesignerGroup>

    </PropertyItem>

    <PropertyItem padded :header="'Options'" :icon="'input-check'" v-if="!input.external">
        <div class="frv2-opts-ditems">

            <div class="frv2-opts-ditem" v-for="(item, optionKey, i) in input.options" :key="'ii' + i" :id="'i' + item.key" :class="[
                {'frv2-opts-ditem-hide': sourceIndex == optionKey}
            ]">

                <div class="frv2-opts-ditem-handle" :id="'h' + item.key">
                    <vap-icon small :icon="'burger'" :color="'ext'" style="pointer-events: none;" />
                </div>

                <div class="frv2-opts-ditem-default" @click="onRadioInput(optionKey)">
                    <CheckboxUI :checked="item.default" />
                </div>

                <!-- <div class="frv2-opts-ditem-key">
                    <input v-model="item.key" />
                </div> -->

                <div class="frv2-opts-ditem-text">
                    <DesignerInput v-model="item.locale[$root.locale.key]" @before="$emit('propinput', 'text', 'check_option_text', $event)" />
                </div>

                <!-- <div class="frv2-opts-item-kyc" @click="$emit('kyc', item)">
                    {{ item.kycKey }}
                </div> -->

                <div class="frv2-opts-ditem-logic-d" @click="$emit('kyc', item)">
                    <vap-icon tiny :icon="'eye'" :color="'ext'" />
                </div>

                <div class="frv2-opts-ditem-delete" @click="onTranslationsClicked(optionKey)" v-if="reference.allowTranslation">
                    <vap-icon tiny :icon="'locale'" :color="'ext'" />
                </div>

                <div class="frv2-opts-ditem-delete" @click="deleteCheckboxOption(optionKey)">
                    <vap-icon tiny :icon="'delete'" :color="'ext'" />
                </div>

                <div class="frv2-opts-ditem-drop" v-if="isDragging"
                    @dragenter="onDragEnter(i)"
                    @dragleave="onDragLeave"
                    @drop="handleDrop($event, optionKey, true)"
                    :class="{'frv2-opts-ditem-hover': hoveredIndex == i }"
                />
                <div class="frv2-opts-ditem-drop frv2-opts-ditem-drop2" v-if="isDragging && i == Object.keys(input.options).length - 1"
                    @dragenter="onDragEnter(i + 1)"
                    @dragleave="onDragLeave"
                    @drop="handleDrop($event, optionKey, false)"
                    :class="{'frv2-opts-ditem-hover2': hoveredIndex == i + 1 }"
                />

            </div>

            <div class="frv2-opts-ditems-add">
                <div class="frv2-opts-ditems-add-text">
                    {{ Object.keys(input.options).length + ' options' }}
                </div>
                <div class="frv2-opts-ditems-add-button" @click="addCheckboxOption">
                    <vap-icon small :icon="'add'" />
                </div>
            </div>

        </div>
    </PropertyItem>

</div>
</template>
<script>
import textHelper from '../../textHelper';
import editorHelper from '../../editorHelper';

import PropertyItem from './PropertyItem.vue';
import DesignerGroup from '../ui/inputs/DesignerGroup.vue';
import DesignerLabel from '../ui/inputs/DesignerLabel.vue';
import DesignerInput from '../ui/inputs/DesignerInput.vue';
import DesignerCheckbox from '../ui/inputs/DesignerCheckbox.vue';
import DesignerDropdown from '../ui/inputs/DesignerDropdown.vue';
import CheckboxUI from '../ui/CheckboxUI.vue';

export default {
    name: 'CheckboxProperties',
    components: {
        PropertyItem,
        DesignerGroup,
        DesignerLabel,
        DesignerInput,
        DesignerCheckbox,
        DesignerDropdown,
        CheckboxUI,
    },
    props: {
        reference: { type: Object, default: null },
        input: { type: Object, default: null },
    },
    data() {
        return {
            isDragging: false,
            sourceIndex: -1,
            hoveredIndex: -1,
        }
    },
    methods: {

        onTranslationsClicked(optionKey) {
            this.$emit('trans', this.input.options[optionKey].locale);
        },
        
        deleteCheckboxOption(optionKey) {
            editorHelper.onChange(this.reference, 'check_option_del', false);
            this.$delete(this.input.options, optionKey);
        },

        addCheckboxOption() {
            editorHelper.onChange(this.reference, 'check_option_add', false);

            this.reference.counter += 1;
            const key = 'x' + this.reference.counter;

            this.$set(this.input.options, key, {
                type: 'opt',
                key: key,
                default: false,
                locale: textHelper.getEmptyTextObject(this.reference),
            });
            
            this.enableDragging();
        },

        onRadioInput(optionKey) {
            editorHelper.onChange(this.reference, 'check_option_default', false);
            this.input.options[optionKey].default = !this.input.options[optionKey].default;
        },

        onDragStart(index) {
            this.isDragging = true;
            
            this.$nextTick(() => {
                const stuff = document.getElementsByClassName('frv2-opts-ditem-drop');
                stuff.forEach(el => el.addEventListener('dragover', event => {
                    event.preventDefault();
                }));
            });

            const self = this;
            setTimeout(function() {
                self.sourceIndex = index;
            }, 10);
        },

        onDragEnd() {
            this.isDragging = false;
            this.sourceIndex = -1;
        },

        onDragEnter(index) {
            this.hoveredIndex = index;
        },

        onDragLeave() {
            this.hoveredIndex = -1;
        },

        handleDrop(e, index, before) {
            //const data = e.dataTransfer.getData("text/aml");
            editorHelper.onChange(this.reference, 'check_option_move', false);

            this.onDragLeave();
            this.isDragging = false;

            const newObject = {};

            for (const key in this.input.options) {
                if (before && key == index) {
                    newObject[this.sourceIndex] = this.input.options[this.sourceIndex];
                }
                if (key != this.sourceIndex) newObject[key] = this.input.options[key];
                if (!before && key == index) {
                    newObject[this.sourceIndex] = this.input.options[this.sourceIndex];
                }
            }

            this.$set(this.input, 'options', newObject);
            this.$emit('reselect');
        },

        enableDragging() {
            const self = this;
            this.$nextTick(() => {
                for (const i in this.input.options) {
                    const draggable = document.getElementById('i' + this.input.options[i].key);
                    const handle = document.getElementById('h' + this.input.options[i].key);
                    handle.onmousedown = function(e) {
                        e.target.parentNode.setAttribute('draggable', 'true')
                    };
                    handle.onmouseup = function(e) {
                        e.target.parentNode.setAttribute('draggable', 'false')
                    };
                    draggable.ondragstart = function(e) {
                        e.dataTransfer.setData('text/aml', self.input.options[i].key);
                        self.onDragStart(i);
                    };
                    draggable.ondragend = function(e) {
                        e.target.setAttribute('draggable', 'false');
                        self.onDragEnd();
                    };
                }
            });
        },


    },
    created() {
        this.enableDragging();
    }
}
</script>
<style scoped>

.frv2-opts-ditems {
    float: left;
    width: 100%;
    padding: 0px 5px;
    box-sizing: border-box;
    margin-top: 10px;
    margin-bottom: 5px;
}

.frv2-opts-ditem {
    position: relative;
    display: flex;
    height: 26px;
    margin-top: -1px;
    border: solid 1px var(--fb-menu-b);
    background-color: var(--fb-input-bg);
}

.frv2-opts-ditem-hide {
    display: none;
}

.frv2-opts-ditem-handle {
    width: 31px;
    padding-top: 0px;
    padding-left: 2px;
    fill: var(--fb-menu-a);
    box-sizing: border-box;
    cursor: pointer;
}
.frv2-opts-ditem-handle:hover {
    fill: var(--fb-menu-b);
    background-color: var(--fb-menu-a);
}

.frv2-opts-ditem-default {
    padding-top: 1px;
    padding-left: 0px;
    width: 26px;
    border-left: solid 1px var(--fb-menu-b);
    box-sizing: border-box;
    cursor: pointer;
}

.frv2-opts-ditem-key {
    width: 70px;
    border-left: solid 1px var(--fb-menu-b);
}
.frv2-opts-ditem-key input {
    border: none; outline: none; background: none;
    width: 100%; height: 100%;
    box-sizing: border-box;
    padding-left: 6px;
    padding-top: 2px;
    font-size: 15px;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    color: white;
    opacity: 0.6;
}

.frv2-opts-ditem-text {
    flex-grow: 100;
    border-left: solid 1px var(--fb-menu-b);
}

.frv2-opts-ditem-text input {
    border: none; outline: none; background: none;
    width: 100%; height: 100%;
    box-sizing: border-box;
    padding-left: 6px;
    padding-top: 2px;
    font-size: 15px;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    color: white;
    opacity: 0.8;
}

.frv2-opts-ditem-delete {
    width: 28px;
    padding-top: 2px;
    padding-left: 2px;
    fill: gray;
    border-left: solid 1px var(--fb-menu-b);
    cursor: pointer;
    box-sizing: border-box;
}
.frv2-opts-ditem-delete:hover {
    background-color: var(--fb-menu-a);
}

.frv2-opts-ditem-logic-d {
    width: 28px;
    padding-top: 2px;
    padding-left: 2px;
    fill: gray;
    border-left: solid 1px var(--fb-menu-b);
    cursor: pointer;
    box-sizing: border-box;
}
.frv2-opts-ditem-logic-d:hover {
    background-color: var(--fb-menu-a);
}

.frv2-opts-ditem-drop {
    position: absolute;
    top: -6px; height: 11px;
    left: 60px; right: 60px;
    border-radius: 5px;
    border: solid 1px var(--fb-menu-b);
    background-color: var(--text-weak);
    opacity: 0.3;
}
.frv2-opts-ditem-hover {
    opacity: 0.8;
    top: -8px; height: 17px;
}

.frv2-opts-ditem-drop2 {
    top: 25px;
}
.frv2-opts-ditem-hover2 {
    opacity: 0.8;
    top: 22px; height: 17px;
}

.frv2-opts-ditems-add {
    display: flex;
    margin-top: -1px;
}

.frv2-opts-ditems-add-text {
    flex-grow: 100;
    font-size: 14px;
    color: var(--text-weak);
    padding-top: 8px;
    padding-left: 12px;
}

.frv2-opts-ditems-add-button {
    width: 28px;
    border: solid 1px var(--fb-menu-b);
    cursor: pointer;
}
.frv2-opts-ditems-add-button:hover {
    background-color: var(--item-hover);
}

</style>